angular.module('core')
  .controller('ChooseStandardModalController', [
    '$cookies',
    '$scope',
    '$rootScope',
    '$state',
    '$cachedResource',
    'teacherApi',
    'edxAcademicMappingsApi',
    'authentication',
    'edxFeatureFlagService',
  function(
    $cookies,
    $scope,
    $rootScope,
    $state,
    $cachedResource,
    $teacherApi,
    edxAcademicMappingsApi,
    authentication,
    featureFlagService) {

    $scope.isAstRestrictionEnabled = isAstRestrictionEnabled;

    function isAstRestrictionEnabled() {
      return featureFlagService.isAstRestrictionEnabled();
    }

    var systemAcademicStandardsList = function() {

      if (!featureFlagService.isAstRestrictionEnabled()) {
        $teacherApi.getAcademicStandards(function (academic_standards) {
          $scope.academicStandardsList = academic_standards;
        });
      } else {
        edxAcademicMappingsApi.getAcademicStandardsForDistrict($state.params.districtId).then(function (academic_standards) {
          $scope.academicStandardsList = academic_standards;
        });
      }
    };

    systemAcademicStandardsList();

    $scope.modalClose = function() {
      $rootScope.$broadcast('modalClose');
    };

    $scope.handleStandardClick = function(standard) {
      var customer = authentication.getCustomer();
      // set the saved standard on the teacher/customer object
      customer.academic_standard_name = standard.name;
      customer.academic_standard_title_in_reports = standard.title_in_reports;

      if (!authentication.isGuardian(customer)) {
        // save the teacher with updated standard
        $teacherApi.saveTeacherProductSettings(customer);
      } else {
        // save guardian ast in cookie
        authentication.saveAstToCookie(standard.name, standard.title_in_reports);
      }

      //we've saved standards data that needs to be used for the session until next login, update it.
      $cachedResource.clearCache({where: ['CustomerNavigation']});
      $rootScope.$emit('customerInfoSet', customer);

      // since the IDs for levels, domains, standards, and clusters vary across standard, any saved values are now irrelevant - starts user off at default all domains tab
      $state.params.standards = "";
      // angular page reload w/o actual browser page reload
      $state.go($state.current, $state.params, {reload: true});
      $scope.modalClose();
    };

    $scope.closeModalWithKeyboard = function($event){
      if ($event.keyCode === 13 || $event.keyCode === 32) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.modalClose();
      }
    };

  }]);
